
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/saisoneroeffnung-skigebiete",
      function () {
        return require("private-next-pages/[region]/saisoneroeffnung-skigebiete.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/saisoneroeffnung-skigebiete"])
      });
    }
  